<template>
  <AuthBox>
    <h1 class="auth-title">{{ $t('content.reset_title') }}</h1>
    <div class="auth-subtitle mb-6">{{ $t('content.reset_subtitle') }}</div>
    <form @submit.prevent="submit">
      <form-group :name="$t('form.pass1')" :validator="$v.form.pass1" style="margin-bottom: 8px !important;">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.pass1"
            v-bind="{ ...attrs, errorMessages: attrs.errorMessages?.filter(msg => msg.includes('required')) }"
            :label="$t('form.pass1')"
            :append-icon="!showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            @input="$v.form.pass1.$touch()"
            @blur="$v.form.pass1.$touch()"
          />
        </template>
      </form-group>

      <PasswordRequirements :model-value="form.pass1" />

      <form-group :name="$t('form.pass2')" :validator="$v.form.pass2">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.pass2"
            v-bind="attrs"
            :label="$t('form.pass2')"
            :append-icon="!showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword2 ? 'text' : 'password'"
            @click:append="showPassword2 = !showPassword2"
            @input="$v.form.pass2.$touch()"
            @blur="$v.form.pass2.$touch()"
          />
        </template>
      </form-group>
      <v-btn block color="primary btn-primary-custom" type="submit" class="mt-4" :loading="loading">{{ $t('save') }}</v-btn>
    </form>
  </AuthBox>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { hasNumber, hasSpecialChar, hasUppercase } from '@/validators/shared';
import FormGroup from '@/components/base/FormGroup';
import AuthBox from '@/components/base/AuthBox';
import PasswordRequirements from '@/components/PasswordRequirements.vue';

export default {
  name: 'AuthChangePassword',
  components: {
    AuthBox,
    FormGroup,
    PasswordRequirements
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  layout: 'empty',
  validations: {
    form: {
      pass1: { required, minLength: minLength(6), hasNumber, hasUppercase, hasSpecialChar },
      pass2: { required, sameAsPassword: sameAs('pass1') }
    }
  },
  data: () => ({
    form: {
      pass1: '',
      pass2: ''
    },
    loading: false,
    showPassword: false,
    showPassword2: false
  }),
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return false;
      this.loading = true;
      this.$axios
        .post(`/api/auth/change_password`, {
          password: this.form.pass1,
          confirmPassword: this.form.pass2
        })
        .then(() => {
          this.$store.commit('Auth/SET_USER', { verified: true });

          const roleId = this.user.roleId;
          const verified = this.user.verified;
          const student = this.user.student;
          const classroomStatus = this.user.classroomStatus;
          const classroomStatusDetail = this.user.classroomStatusDetail;
          const cerdasTypeId = this.user.cerdasTypeId;

          if (roleId === 1 && verified) {
            this.$router.push({ name: 'ReportAdminIndex' });
          } else if (roleId === 2 && verified) {
            this.$router.push({ name: 'MasterUserSchool' });
          } else if (roleId === 6 && verified) {
            this.$router.push({ name: 'StudentIndex' });
          } else if (roleId === 3 && verified && student == true && classroomStatus == true) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == true) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == false) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == false) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 1) {
            this.$store.commit('Auth/SET_GUIDE_POP', { guidePopUp: true });
            this.$router.push({ name: 'CourseIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 2) {
            this.$router.push({ name: 'TeacherClassIndex' });
          } else if (roleId === 5 && verified) {
            this.$router.push({ name: 'StudentClassIndex' });
          } else if (roleId && !verified) {
            this.$router.push({ name: 'AuthChangePassword' });
          }

          localStorage.setItem('notif', 0);

          // const redirect = ['ReportAdminIndex', 'MasterUserSchool', 'ParentCourseIndex', 'TeacherClassIndex', 'StudentCourseIndex'];
          // this.$router.push({ name: redirect[this.user.roleId - 1], replace: true });
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => this.$router.go(), 100);
        });
    }
  },
  created() {
    this.$store.commit('Auth/SET_GOOGLE_AUTH_CLEAR');
  }
};
</script>
